import { type FC, type PropsWithChildren, useEffect } from 'react';
import { useAccount } from '@/hooks/data/account/useAccount';
import { useCapabilities } from '@/hooks/useCapabilities';
import { type TermAcceptanceStatus } from '@/types/terms';
import { useCurrentPage } from '@/hooks/useCurrentPage';
import { Loading } from '@/components/loading';
import { useRouter } from 'next/router';

export const ACCEPTANCE_REQUIRED: TermAcceptanceStatus = 'acceptance_required';
export const UP_TO_DATE: TermAcceptanceStatus = 'up_to_date';

export const TermsAcceptanceGuard: FC<PropsWithChildren> = ({ children }) => {
  const router = useRouter();

  const { profile, profileLoading } = useAccount();
  const { isPublicSharePage } = useCurrentPage();
  const { canViewTerms } = useCapabilities();

  const requiresAcceptance = canViewTerms && profile?.termsAcceptanceStatus === ACCEPTANCE_REQUIRED;

  useEffect(() => {
    if (!requiresAcceptance) {
      return;
    }

    void router.replace('/terms');
  }, [requiresAcceptance, router]);

  if (!isPublicSharePage && (profileLoading || !profile || requiresAcceptance)) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-white dark:bg-neutral-950">
        <Loading />
      </div>
    );
  }

  return children ?? null;
};
